import { useState } from "react";
import { useWebSocketApi } from "../hooks/useWebSocketApi";
import { BusinessOperationDetails } from "../Types/BusinessOperationTypes";

export function useQueryBusinessUnenrolment() {
  const websocket = useWebSocketApi("businessUnenrolment");
  const [businessUnenrolmentResponse, setBusinessUnenrolmentResponse] = useState<BusinessOperationDetails>();
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchBusinessUnenrolment = (businessIds: string[], optOutReason: string) => {
    if (isFetching || !businessIds) return;

    setIsFetching(true);
    setError(null);

    websocket.connect({
      onOpen: () => {
        websocket.sendMessage({ inputId: businessIds, optOutReason });
      },
      onMessage: (event) => {
        try {
          setBusinessUnenrolmentResponse(JSON.parse(event.data));
        } catch (e) {
          setError("Failed to parse WebSocket message.");
        } finally {
          setIsFetching(false);
          websocket.closeConnection();
        }
      },
      onError: () => {
        setError("WebSocket error occurred.");
        setIsFetching(false);
        websocket.closeConnection();
      },
    });
  };

  return { fetchBusinessUnenrolment, isFetching, error, businessUnenrolmentResponse };
}
